import React from 'react';
import cx from 'classnames';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import TypographySwitcher from '../TypographySwitcher';

import styles from './index.module.scss';

export enum IconPosition {
  LEFT = 'left',
  RIGHT = 'right',
}

export enum BackgroundColor {
  GRADIENT = 'gradient',
  RED = 'red',
  GREEN = 'green',
}

const BackgroundColorMap: Record<BackgroundColor, string> = {
  [BackgroundColor.GRADIENT]:
    'linear-gradient(90deg, rgba(85, 68, 148, 1) 0%, rgba(255, 97, 69, 1) 100%)',
  [BackgroundColor.RED]: '#c8585f',
  [BackgroundColor.GREEN]: '#7C9179',
};

export interface TextBannerWithIconProps {
  iconUrl?: string;
  iconAlt?: string;
  text: string;
  iconPosition?: IconPosition;
  backgroundColor?: BackgroundColor;
}

const TextBannerWithIcon: React.FC<TextBannerWithIconProps> = ({
  iconUrl,
  iconAlt,
  text,
  iconPosition = IconPosition.LEFT,
  backgroundColor = BackgroundColor.RED,
}) => {
  const backgroundColorStyle = BackgroundColorMap[backgroundColor];
  const iconPositionRight = iconPosition === IconPosition.RIGHT;

  return (
    <div
      className={cx(styles.wrapper, {
        [styles.iconRight]: iconPositionRight,
      })}
      style={{ background: backgroundColorStyle }}
    >
      {iconUrl && <img src={iconUrl} alt={iconAlt} className={styles.icon} />}
      <TypographySwitcher
        mobile='subtitle2'
        tablet='subtitle1'
        desktop='subtitle1'
        className={cx(styles.text, { [styles.noMargin]: !iconUrl })}
      >
        <Markdown rehypePlugins={[rehypeRaw]}>{text}</Markdown>
      </TypographySwitcher>
    </div>
  );
};

export default TextBannerWithIcon;
